import { render, staticRenderFns } from "./CourseLeadersPage.vue?vue&type=template&id=43301fb0&scoped=true&lang=pug"
import script from "./CourseLeadersPage.vue?vue&type=script&lang=js"
export * from "./CourseLeadersPage.vue?vue&type=script&lang=js"
import style0 from "./CourseLeadersPage.vue?vue&type=style&index=0&id=43301fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43301fb0",
  null
  
)

export default component.exports